import {
  Module,
  VuexModule,
  Mutation,
  Action,
} from 'vuex-module-decorators';

import {
  BASE_URL,
  INVITE_FRIEND_FETCH,
  INVITE_FRIEND_EDIT,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'invitefriend' })
export default class InviteFriend extends VuexModule {
  inviteFriendList: any = [];

  @Mutation
  mutateInviteFriend(list) {
    this.inviteFriendList = list;
  }

  @Action({ commit: 'mutateInviteFriend' })
  FetchInviteFriends(params = {}) {
    return Vue.axios({
      url: BASE_URL + INVITE_FRIEND_FETCH,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => {
        const { code } = data.status;
        if (code === 0) {
          return data.data;
        } else {
          throw data.status;
        }
      })
      .catch((err) => err);
  }

  @Action
  UpdateUrl(params) {
    return Vue.axios({
      url: BASE_URL + INVITE_FRIEND_EDIT,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data.status)
      .catch((err) => err);
  }
}
